import { Banner, RichTextBody } from 'component-library';
import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { useBannersV2 } from './BannerProvider';

export const SiteBanner = ({ scope }: { scope?: string }) => {
  const { pathname } = useLocation();

  if (!scope) {
    const firstPathSegment = pathname.split('/')[1];

    switch (firstPathSegment) {
      case 'pickups':
        scope = 'orderpickup';
        break;
      case 'followup':
        scope = 'followup';
        break;
      case 'co2impact':
        scope = 'co2impact';
        break;
      case 'csrd':
        scope = 'csrd';
        break;
      case 'admin':
        scope = 'admin';
        break;
    }
  }

  const { getBannerForScope, isLoading } = useBannersV2();

  const bannersToShow = useMemo(() => {
    if (!isLoading && scope) {
      const banners = getBannerForScope(scope);

      return banners;
    }

    if (isLoading) {
      return [];
    }

    return [];
  }, [getBannerForScope, isLoading, scope]);

  return bannersToShow.map((banner) => (
    <Banner
      key={banner.id}
      type={banner.bannerLevel}
      title={banner.title}
      scope={scope ?? 'global'}
    >
      <RichTextBody body={banner.body} whitelist={['a']} blackLinks={true} />
    </Banner>
  ));
};
